var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.7647 36.4257C87.7647 35.0665 86.6603 33.9609 85.3061 34.0011C41.286 35.3053 6 71.5183 6 116H30.5294C30.5294 84.2852 56.1545 58.5753 87.7647 58.5753V36.4257Z",
    fill: "#FEFE53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7647 116H145C145 84.2852 119.375 58.5753 87.7647 58.5753V116Z",
    fill: "#FEFE53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo);
export default __webpack_public_path__ + "static/media/brandLogo.d573f114ab11329595bdf1e76caeff86.svg";
export { ForwardRef as ReactComponent };